import React, { FunctionComponent } from 'react';
import { FinderAction } from '@/pages/visa-finder';
import { LinkButton } from '@visalex/core';

import { useTranslation } from 'next-i18next';

const VisaFinderActionFooter: FunctionComponent<FinderAction> = () => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column align-items-center d-sm-block mx-auto ml-md-auto mr-md-0 order-0 order-md-1">
      <LinkButton href="/free-consultation" size="lg" className="mb-3 mb-md-0 order-0 order-sm-1">
        {t('visa-finder.request-consultation')}
      </LinkButton>
    </div>
  );
};

export default VisaFinderActionFooter;
